export const altChip = "Chip";
export const altImmagineLogo = "Immagine Logo";
